export default {
  Niv3_4_PRODUITS: "Page_Descente_Produits",
  Niv3_4_MEA: {
    desktop: "Page_Descente_MEA",
    mobile: "Mobile_Page_Descente_MEA"
  },
  GRID_NIV3: {
    desktop: {
      Grid: "Grid_Page_Descente_Galerie",
      List: "Grid_Page_Descente_Liste",
      Mode: "Grid_Page_Descente_Mode"
    },
    mobile: {
      Grid: "Mobile_Grid_Page_Descente_Galerie"
    }
  },
  FIRST_PUSH_GRID_MODE: 3,
  FIRST_PUSH_MOBILE_GRID_MODE: 4,
  SECOND_PUSH_GRID_MODE: 13,
  FIRST_PUSH_LIST_MODE: 3,
  SECOND_PUSH_LIST_MODE: 6,
  LIST_COLUMN_NUMBER: 4,
  MOBILE_MAX_LENGTH_ADVANTAGE: 30,
  DEFAULT_MAX_LENGTH_ADVANTAGE: 40,
  DP_SPARKOW_REVIEWS_CODE: 'NW-13781-avis',
  DP_SPARKOW_PRICE_CODE: 'NW-327-prix',
  DP_SPARKOW_NUTRISCORE_CODE: 'NW-13743-nutri_score',
  SEARCH_SPARKOW_REVIEWS_CODE: 'D_MEILLEURES_NOTES_VIRTUELLE',
  SEARCH_SPARKOW_NUTRISCORE_CODE: 'D_NUTRISCORE',
  COLOR_RENDER_MODE: 'Coloris',
  BRAND_RENDER_MODE: 'Marques',
  NUTRISCORE_RENDER_MODE: 'Nutriscore',
  ENERGITIQUE_CLASS_RENDER_MODE: 'Energetique',
  REVIEW_RENDER_MODE: 'Avis',
  QUICKFILTER_LIST_RENDER_MODE: 'Filtres_rapides_deroulant',
  SLIDER_MODE: 'Slider',
  BOOLEAN_MODE: 'Boolean',
  BANNIERE_MEA: 'Page_Descente_Banniere_MEA',
  EXPLICATIONS: 'Page_Descente_Texte_Explicatif'
}
